import React, { useEffect, useState } from 'react';
import Accordion from '../../../components/accordion';
import { Spinner } from '../../../platformui';
import { checkForUpdatesHelper } from './check-for-updates-helper';

const ServiceInfoEndedOutagesBlock = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [serviceData, setServiceData] = useState([]);

  useEffect(() => {
    checkForUpdatesHelper(
      props.ServiceInfoApiUrl,
      setIsLoading,
      setServiceData
    );
  }, []);

  return isLoading ? (
    <Spinner Modifiers={{ 'c-spinner--accordion': true }}></Spinner>
  ) : (
    <Accordion props={serviceData} type={props.OutageType} />
  );
};

export default ServiceInfoEndedOutagesBlock;
